// src/components/sections/AboutSection.js
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { slideInLeft, slideInRight } from '../../styles/animations';
import SectionTitle from '../ui/SectionTitle';

const AboutWrapper = styled.section`
  background-color: ${props => props.theme.colors.gray};
  padding: ${props => props.theme.spacing.xl} 0;
`;

const AboutContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 ${props => props.theme.spacing.md};
`;

const AboutGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${props => props.theme.spacing.xl};
  align-items: center;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: 1fr;
    gap: ${props => props.theme.spacing.lg};
  }
`;

const AboutContent = styled.div`
  animation: ${slideInLeft} 0.8s ease-out forwards;
  opacity: 0;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    order: 2;
  }
`;

const AboutText = styled.div`
  margin-bottom: ${props => props.theme.spacing.md};
  
  p {
    margin-bottom: ${props => props.theme.spacing.md};
  }
`;

const AboutFeatures = styled.ul`
  list-style: none;
  margin: 0 0 ${props => props.theme.spacing.lg};
  padding: 0;
`;

const FeatureItem = styled.li`
  display: flex;
  align-items: flex-start;
  margin-bottom: ${props => props.theme.spacing.sm};
  
  svg {
    color: ${props => props.theme.colors.primary};
    margin-right: ${props => props.theme.spacing.sm};
    flex-shrink: 0;
    margin-top: 4px;
  }
`;

const AboutButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  padding: 0;
  background: none;
  border: none;
  color: ${props => props.theme.colors.primary};
  font-weight: 600;
  transition: color ${props => props.theme.transitions.fast};
  text-decoration: none;
  
  svg {
    margin-left: ${props => props.theme.spacing.xs};
    transition: transform ${props => props.theme.transitions.fast};
  }
  
  &:hover {
    color: ${props => props.theme.colors.primaryDark};
    
    svg {
      transform: translateX(5px);
    }
  }
`;

const AboutImageContainer = styled.div`
  position: relative;
  animation: ${slideInRight} 0.8s ease-out forwards;
  opacity: 0;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    order: 1;
    height: 350px;
  }
`;

const AboutImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: ${props => props.theme.borderRadius.medium};
  box-shadow: ${props => props.theme.shadows.medium};
`;

const AboutSection = () => {
    return (
        <AboutWrapper id="about">
            <AboutContainer>
                <AboutGrid>
                    <AboutContent>
                        <SectionTitle text="Bienvenue à l'extérieur" />

                        <AboutText>
                            <p>
                                Le confort de votre intérieur se prolonge astucieusement à l'extérieur. Les lames de bois, de bois composite ou de céramique relient votre jardin à votre baie, bordent votre piscine, ou prolongent les perspectives de votre balcon.
                            </p>
                            <p>
                                Agréablement et sans hésitation, vos pieds nus explorent de nouveaux espaces de vie sous le soleil.
                                Aucun doute, à votre tour vous appréciez déjà l'accueil chaleureux de votre nouvelle surface parée de bois.
                            </p>
                        </AboutText>

                        <AboutFeatures>
                            {[
                                'Matériaux de qualité supérieure et éprouvée !',
                                'Conception sur mesure',
                                'Savoir-faire artisanal',
                                'Finitions impeccables'
                            ].map((feature, index) => (
                                <FeatureItem key={index}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                                    </svg>
                                    <span>{feature}</span>
                                </FeatureItem>
                            ))}
                        </AboutFeatures>

                        <AboutButton to="/entreprise">
                            En savoir plus sur notre entreprise
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z" />
                            </svg>
                        </AboutButton>
                    </AboutContent>

                    <AboutImageContainer>
                        <AboutImage
                            src="https://images.unsplash.com/photo-1595828071663-5e84e3025dcf?q=80&w=2000"
                            alt="Terrasse en bois Decko"
                        />
                    </AboutImageContainer>
                </AboutGrid>
            </AboutContainer>
        </AboutWrapper>
    );
};

export default AboutSection;